export const aciCalendarBack = {
    iconName: 'calendar-back',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 23' },
        path: [
            {
                attr: {
                    'clip-rule': 'evenodd',
                    d: 'M1 4.5A1.5 1.5 0 012.5 3h19A1.5 1.5 0 0123 4.5v16a1.5 1.5 0 01-1.5 1.5h-19A1.5 1.5 0 011 20.5v-16z',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M1 9h22',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M7 6V1M17 6V1',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
